import { AlignedData, Series } from "uplot";
import { Colors } from "../Constant";

function randColor() {
  const color = "#000000".replace(/0/g, function () {
    return (~~(Math.random() * 16)).toString(16);
  });
  return color;
}

function removeTrailingZeroes(inputString: string): number[] {
  // Split the string into an array of substrings based on spaces
  const parts = inputString.split(" ");

  // Convert substrings to numbers
  const numbers = parts.map(Number);

  // Find the index where the trailing zeroes start
  let endIndex = numbers.length;
  while (endIndex > 0 && numbers[endIndex - 1] === 0) {
    endIndex--;
  }

  // Slice the array to remove trailing zeroes and return it
  return numbers.slice(0, endIndex);
}

export function getParsedPointOperationChartData(raw_data: any) {
  const { EVENTDATA1, EVENTTIME } = raw_data;
  const series: Series[] = [];

  const x_axis_set = new Set<number>();

  for (let i = 0; i < EVENTTIME.length; i++) {
    const { ts, value: time_value } = EVENTTIME[i];

    const stroke_color = Colors[i] ?? randColor();

    series.push({
      label: new Date(ts).toLocaleString(),
      stroke: stroke_color,
      spanGaps: true,
      width: 3,
      value: (self: any, rawValue: any) => (rawValue ? rawValue + " mA" : "-"),
      pxAlign: 0.2,
      points: {
        show: EVENTTIME.length < 10 ? true : false,
        size: 6,
        fill: stroke_color,
        // filter: pointsFilter,
        // space: 10
      },
    });

    const sorted_time = removeTrailingZeroes(time_value);
    for (const packet of sorted_time) {
      x_axis_set.add(packet);
    }
  }

  const sorted_x_axis: number[] = Array.from(x_axis_set);
  sorted_x_axis.sort((a: any, b: any) => a - b);
  const data: AlignedData = [sorted_x_axis];

  for (let i = 0; i < EVENTDATA1.length; i++) {
    const { value: time_value } = EVENTTIME[i];
    const { value: data_value } = EVENTDATA1[i];
    const sorted_time = removeTrailingZeroes(time_value);
    const sorted_data = removeTrailingZeroes(data_value);

    const _data = [];

    let pointer = 0;
    for (let j = 0; j < sorted_x_axis.length; j++) {
      if (sorted_time[pointer] === sorted_x_axis[j]) {
        _data.push(sorted_data[pointer]);
        pointer++;
      } else {
        _data.push(null);
      }
    }

    data.push(_data);
  }

  return { data, series };
}

const OPERATOR_PARSER = {
  "<": function (a: number, b: number) {
    return a < b;
  },
  ">": function (a: number, b: number) {
    return a > b;
  },
  "=": function (a: number, b: number) {
    return a === b;
  },
  ">=": function (a: number, b: number) {
    return a >= b;
  },
  "<=": function (a: number, b: number) {
    return a <= b;
  },
};

export function getFilteredPointOperationData(raw_data: any, filterParams: any) {
  console.log("raw_data", raw_data);
  const { key, operator, value: filter_value, direction } = filterParams;
  if (key || operator || filter_value) {
    if (!key || !(key in raw_data) || !operator || !filter_value) return raw_data;
  }

  const valid_index_list = [];

  if (key) {
    for (let index = 0; index < raw_data[key].length; index++) {
      const key_val = raw_data[key][index];
      const { value: raw_val } = key_val;
      const parsed_val = Number(raw_val);

      const compare_func = OPERATOR_PARSER[operator as keyof typeof OPERATOR_PARSER];

      if (compare_func(parsed_val, filter_value)) {
        if (direction && raw_data.OperationType) {
          if (direction !== raw_data.OperationType[index].value) continue;
        }
        valid_index_list.push(index);
      }
    }
  } else if (direction && raw_data.OperationType) {
    console.log("working");
    for (let index = 0; index < raw_data.OperationType.length; index++) {
      const key_val = raw_data.OperationType[index];
      const { value } = key_val;
      console.log("value", value, direction);

      if (value !== direction) continue;

      valid_index_list.push(index);
    }
  }


  const EVENTDATA1: any = [];
  const EVENTTIME: any = [];

  for (const index of valid_index_list) {
    EVENTDATA1.push(raw_data.EVENTDATA1[index]);
    EVENTTIME.push(raw_data.EVENTTIME[index]);
  }

  return { EVENTTIME, EVENTDATA1 };
}

const seriesColors = [
  "#7cb5ec",
  "#434348",
  "#90ed7d",
  "#f7a35c",
  "#8085e9",
  "#f15c80",
  "#e4d354",
  "#2b908f",
  "#f45b5b",
  "#91e8e1",
];
const interpolatedColor = "#fcb0f1";

export function uPlotTooltipPlugin({ onclick, commits, isInterpolated, shiftX = 10, shiftY = 80 }: any) {
  let tooltipLeftOffset = 0;
  let tooltipTopOffset = 0;

  const tooltip = document.createElement("div");
  tooltip.className = "u-tooltip";

  let seriesIdx: any = null;
  let dataIdx: any = null;

  let over: any;

  let tooltipVisible = false;

  function showTooltip() {
    if (!tooltipVisible) {
      tooltip.style.display = "block";
      over.style.cursor = "pointer";
      tooltipVisible = true;
    }
  }

  function hideTooltip() {
    if (tooltipVisible) {
      tooltip.style.display = "none";
      over.style.cursor = null;
      tooltipVisible = false;
    }
  }

  function setTooltip(u: any) {
    showTooltip();

    let top: any = u.valToPos(u.data[seriesIdx][dataIdx], "y");
    let lft: any = u.valToPos(u.data[0][dataIdx], "x");

    tooltip.style.borderColor = u.series?.[seriesIdx]?._stroke ?? seriesColors[seriesIdx - 1];

    // Get the tooltip's dimensions
    const tooltipWidth = tooltip.offsetWidth;
    const tooltipHeight = tooltip.offsetHeight;

    // Get the viewport dimensions
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Calculate the tooltip's new position
    let newTop = tooltipTopOffset + top + shiftY;
    let newLeft = tooltipLeftOffset + lft + shiftX;

    // Adjust position if the tooltip overflows the viewport
    if (newLeft + tooltipWidth > viewportWidth) {
      newLeft = viewportWidth - tooltipWidth - shiftX;
    }

    if (newTop + tooltipHeight > viewportHeight) {
      newTop = viewportHeight - tooltipHeight - shiftY;
    }

    // Set the tooltip's position
    tooltip.style.top = newTop + "px";
    tooltip.style.left = newLeft + "px";

    const time = u.series?.[seriesIdx]?.label;
    const event_time = u.data?.[0]?.[dataIdx];
    const event_data = u.data?.[seriesIdx]?.[dataIdx];

    tooltip.textContent = `At ${event_time} mS` + "\n" + `${time} : ${event_data} mA`;
  }

  return {
    hooks: {
      ready: [
        (u: any) => {
          over = u.over;
          tooltipLeftOffset = parseFloat(over.style.left);
          tooltipTopOffset = parseFloat(over.style.top);
          u.root.querySelector(".u-wrap").appendChild(tooltip);

          let clientX: any;
          let clientY: any;

          over.addEventListener("mousedown", (e: any) => {
            clientX = e.clientX;
            clientY = e.clientY;
          });

          over.addEventListener("mouseup", (e: any) => {
            // clicked in-place
            if (e.clientX == clientX && e.clientY == clientY) {
              if (seriesIdx != null && dataIdx != null) {
                onclick?.(u, seriesIdx, dataIdx);
              }
            }
          });
        },
      ],
      setCursor: [
        (u: any) => {
          const c = u.cursor;

          if (dataIdx != c.idx) {
            dataIdx = c.idx;

            if (seriesIdx != null) setTooltip(u);
          }
        },
      ],
      setSeries: [
        (u: any, sidx: any) => {
          if (seriesIdx != sidx) {
            seriesIdx = sidx;

            if (sidx == null) hideTooltip();
            else if (dataIdx != null) setTooltip(u);
          }
        },
      ],
      drawAxes: [
        (u: any) => {
          const { ctx } = u;
          const { left, top, width, height } = u.bbox;

          const interpolatedColorWithAlpha = "#fcb0f17a";

          ctx.save();

          ctx.strokeStyle = interpolatedColorWithAlpha;
          ctx.beginPath();

          const [i0, i1] = u.series[0].idxs;

          for (let j = i0; j <= i1; j++) {
            const v = u.data[0][j];

            if (isInterpolated && isInterpolated(j)) {
              const cx = Math.round(u.valToPos(v, "x", true));
              ctx.moveTo(cx, top);
              ctx.lineTo(cx, top + height);
            }
          }

          ctx.closePath();
          ctx.stroke();
          ctx.restore();
        },
      ],
    },
  };
}
